import { createSlice } from "@reduxjs/toolkit";
import { SpedState } from "./types";

const INITIAL_STATE: SpedState = {
  singleFile: null,
  error: null,
  processedFile: null,
  processingMessage: null,
};

const spedSlice = createSlice({
  name: "sped",
  initialState: INITIAL_STATE,
  reducers: {
    setSingleFile(state, action) {
      state.singleFile = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    setProcessedFile(state, action) {
      state.processedFile = action.payload;
    },
    setProcessingMessage(state, action) {
      state.processingMessage = action.payload;
    },
    clearFiles(state) {
      state.singleFile = null;
    },
  },
});

export const {
  setSingleFile,
  setError,
  setProcessedFile,
  clearFiles,
} = spedSlice.actions;

export default spedSlice.reducer;
